import clsx from 'clsx';
import { IconChevronRight } from '@tabler/icons-react';
import React, { type Ref } from 'react';
import Image from 'next/image';
import { Button } from '@/components/ui/button';

type CategorySelectTriggerProps = {
  ref?: Ref<HTMLButtonElement>;
  label?: string;
  current?: string;
  className?: string;
  onClick?: () => void;
  leftIcon?: React.ReactNode;
  isOpened?: boolean;
  isLocked?: boolean;
  lockedTopName?: string;
};

export function CategorySelectTrigger({
  ref,
  label = '',
  current = '',
  className,
  onClick,
  leftIcon,
  isOpened = false,
  isLocked = false,
  lockedTopName,
  ...props
}: CategorySelectTriggerProps) {
  return (
    <Button
      ref={ref}
      {...props}
      onClick={onClick}
      type='button'
      variant='ghost'
      className={clsx(
        'h-auto w-full justify-between gap-[12px] px-0 font-normal hover:bg-transparent active:scale-100',
        isLocked && lockedTopName ? 'min-h-[46px] py-[6px]' : 'h-[46px]',
        className,
      )}
    >
      <div className='flex items-center gap-[12px]'>
        <div className='flex items-center shrink-0 justify-center size-[46px] rounded-full bg-surface-lightest'>
          <Image width={24} height={24} src='/assets/icons/category-pin.svg' alt='category' />
        </div>
        <div className='flex flex-col items-start'>
          {isLocked && lockedTopName && (
            <span className='text-[12px] text-text-disabled-day leading-[16px]'>{lockedTopName}</span>
          )}
          <p className='text-primary line-clamp-2 break-after-right text-[17px] font-medium text-start leading-[22px]'>
            {current}
          </p>
        </div>
      </div>
      <div className='size-[24px] flex items-center justify-center shrink-0'>
        <IconChevronRight className='text-icon-default rtl:rotate-180' />
      </div>
    </Button>
  );
}
